<mat-icon class="mr-5">link</mat-icon>
<span class="mr-5">{{ 'reports.public' | translate }}</span>
<app-report-share-public-copy-link type="icon"
                                   [link]="link"></app-report-share-public-copy-link>

